



















import Vue from "vue";
import BasicCardTemplate from "./BasicCardTemplate.vue";

export default Vue.extend({
  name: "UnreadMessagesCard",
  props: {
    unreadMessageCount: { type: Number }
  },
  methods: {
    redirectToEmail() {
      this.$router.push("/email");
    }
  }
});
